/**
 * SB6-ANA-CACHE-03 — React surface over the persistence grant/deny store.
 * Refreshes the persisted status on mount (no prompt) so the storage UI reads
 * truthfully even before the first pin/download.
 */
import { useEffect, useSyncExternalStore } from "react";
import { persistenceStore, type PersistState } from "./persistence.js";

export function usePersistenceState(): PersistState {
  useEffect(() => {
    void persistenceStore.refresh();
  }, []);
  return useSyncExternalStore(
    persistenceStore.subscribe,
    persistenceStore.getState,
    persistenceStore.getState,
  );
}
